export default "__VITE_ASSET__D$VUjhB___"